<template>
  <b-row>
    <b-col
      class="col-8"
    >
      <h2>
        Kalender:
      </h2>
    </b-col>
    <b-col
      class="col-4"
    >
      <div
        class="float-right"
      >
        <b-button
          v-if="isNotSafari()"
          class="btn-success"
          @click="CHANGE_VIEW"
        >
          <b-icon-list
            v-if="!mobile"
          />
          <b-icon-calendar-week
            v-if="mobile"
          />
        </b-button>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { BButton, BCol, BIconCalendarWeek, BIconList, BRow } from 'bootstrap-vue'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'CalendarHeader',
  components: {
    BIconCalendarWeek,
    BIconList,
    BButton,
    BCol,
    BRow
  },
  computed: {
    ...mapGetters('calendar', [
      'getView'
    ]),
    mobile () {
      return this.getView
    }
  },
  methods: {
    ...mapMutations('calendar', [
      'CHANGE_VIEW'
    ]),
    isNotSafari () {
      return !this.isSafari()
    },
    isSafari () {
      return /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
    }
  }
}
</script>

<style scoped>

</style>
